import Vue from 'vue'
import store from '../store'

const state = {
  isAdding: false
}

const actions = {
  ADD_REPORT_ISSUE: ({commit}, submitData) => {
    commit('SET_IS_ADDING_REPORT_ISSUE', true)
    const url = 'orders/' + submitData.order_id + '/report-issue'
    Vue.http.post(url, submitData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_IS_ADDING_REPORT_ISSUE', false)
        if (!response.error) {
          const data = {
            key: 'order_report_issue',
            value: response.order_report_issue
          }
          store.commit('orderDetail/UPDATE_ORDER_DETAIL_DATA', data)
        }
      })
  }
}

const mutations = {
  SET_IS_ADDING_REPORT_ISSUE: (state, status) => {
    state.isAdding = status
  }
}

const getters = {
  getState: state => {
    return state
  },
  isAdding: state => {
    return state.isAdding ? 'message.button.loading' : 'message.button.submit'
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/report.issue.js